/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePlanRequest
 */
export interface CreatePlanRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePlanRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlanRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlanRequest
     */
    ownerUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlanRequest
     */
    boundaryId?: string;
    /**
     * 
     * @type {Date}
     * @memberof CreatePlanRequest
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreatePlanRequest
     */
    targetEndDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof CreatePlanRequest
     */
    budgetTotal?: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePlanRequest
     */
    budgetCurrency?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlanRequest
     */
    drivenBy?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlanRequest
     */
    effectTenantId?: string;
}

/**
 * Check if a given object implements the CreatePlanRequest interface.
 */
export function instanceOfCreatePlanRequest(value: object): value is CreatePlanRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreatePlanRequestFromJSON(json: any): CreatePlanRequest {
    return CreatePlanRequestFromJSONTyped(json, false);
}

export function CreatePlanRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePlanRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'ownerUserId': json['ownerUserId'] == null ? undefined : json['ownerUserId'],
        'boundaryId': json['boundaryId'] == null ? undefined : json['boundaryId'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'targetEndDate': json['targetEndDate'] == null ? undefined : (new Date(json['targetEndDate'])),
        'budgetTotal': json['budgetTotal'] == null ? undefined : json['budgetTotal'],
        'budgetCurrency': json['budgetCurrency'] == null ? undefined : json['budgetCurrency'],
        'drivenBy': json['drivenBy'] == null ? undefined : json['drivenBy'],
        'effectTenantId': json['effectTenantId'] == null ? undefined : json['effectTenantId'],
    };
}

export function CreatePlanRequestToJSON(json: any): CreatePlanRequest {
    return CreatePlanRequestToJSONTyped(json, false);
}

export function CreatePlanRequestToJSONTyped(value?: CreatePlanRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'ownerUserId': value['ownerUserId'],
        'boundaryId': value['boundaryId'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString().substring(0,10)),
        'targetEndDate': value['targetEndDate'] == null ? undefined : ((value['targetEndDate']).toISOString().substring(0,10)),
        'budgetTotal': value['budgetTotal'],
        'budgetCurrency': value['budgetCurrency'],
        'drivenBy': value['drivenBy'],
        'effectTenantId': value['effectTenantId'],
    };
}

